import { ReactNode } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { User } from '../main'

interface LayoutProps {
  children: ReactNode
  user?: User
  onSignOut?: () => void
}

export function Layout({ children, user, onSignOut }: LayoutProps) {
  const location = useLocation()

  const isActive = (path: string) => location.pathname === path

  return (
    <div className="layout">
      <header className="header">
        <nav className="nav">
          <div className="nav-brand">
            <Link to="/" className="brand-link">
              <h2>SWGRealms</h2>
              <span className="brand-subtitle">Play Platform</span>
            </Link>
          </div>
          
          <div className="nav-links">
            <Link 
              to="/dashboard" 
              className={`nav-link ${(isActive('/dashboard') || isActive('/')) ? 'active' : ''}`}
            >
              Dashboard
            </Link>
            <Link 
              to="/galaxies" 
              className={`nav-link ${isActive('/galaxies') ? 'active' : ''}`}
            >
              Galaxies
            </Link>
            <Link 
              to="/profile" 
              className={`nav-link ${isActive('/profile') ? 'active' : ''}`}
            >
              Profile
            </Link>
          </div>

          <div className="nav-auth">
            {user ? (
              <div className="user-menu">
                <div className="user-info">
                  <span className="username">{user.username}</span>
                  <span className="status-indicator status-online">
                    <span>●</span> online
                  </span>
                </div>
                <button 
                  className="btn btn-secondary"
                  onClick={onSignOut}
                  style={{ marginLeft: 'var(--swg-spacing-sm)', fontSize: '0.8rem', padding: '4px 8px' }}
                >
                  Sign Out
                </button>
              </div>
            ) : (
              <div className="user-menu">
                <span className="username">Guest</span>
              </div>
            )}
          </div>
        </nav>
      </header>

      <main className="main">
        {children}
      </main>

      <footer className="footer">
        <p>&copy; 2025 SWGRealms. All rights reserved.</p>
      </footer>
    </div>
  )
}
